import React, { Component } from 'react'
import { Modal, Button, Row, Col, Select, Input } from 'antd';
import $ from 'jquery';

const Option = Select.Option;

class RequestJoin extends Component {

    constructor( props ){
        super( props );

        this.state = {
            visible: false,
            company: [],
            company_id: '',
            employee_email: ''
        }

        this.handleCancel = this.handleCancel.bind( this );
        this.handleOk = this.handleOk.bind( this );
        this.handleCompany = this.handleCompany.bind( this ); 

    }

    componentWillReceiveProps( nextProps ){

         // Clear Input
         $('input').val( '' );
        
        if( nextProps.company ){
            this.setState({
                company: nextProps.company
            })
        }

        this.setState({
            visible: nextProps.onModal,
            company_id: '',
            employee_email: ''
        });

    }

    handleOk(){

        let data = {
            company_id: this.state.company_id,
            employee_email: this.state.employee_email
        }

        if( data.company_id !== '' && data.employee_email !== '' ){
            this.props.onSubmit( data );
            this.setState({ visible: false });
        }

    }

    handleCancel(){
        this.setState({
            visible: false,
        });
    }

    handleCompany( value ){
        this.setState({
            company_id: value
        })
    }

    render() {

        const list_company = this.state.company.map( ( item, i ) => <Option key={ item.company_id } >{ item.company_name }</Option>  )

        return (
            <div>

                <Modal
                    maskClosable={ false }
                    visible={this.state.visible}
                    title="Request To Joins"
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}>
                    
                    <Row className="mrg_b_10">
                        <Col span={24}>
                            <label>Select Company</label>
                            <Select 
                                value={ this.state.company_id }
                                style={{ width: '100%' }} onChange={ this.handleCompany }>
                                { list_company }
                            </Select>
                        </Col>
                    </Row>

                    <Row className="mrg_b_10">
                        <Col span={24}>
                            <label>Employee Email Address</label>
                            <Input 
                                onChange={ (e) => this.setState({ employee_email: e.target.value }) } />
                        </Col>
                    </Row>

                </Modal>
                
            </div>
        )
    }
}

export default RequestJoin


// WEBPACK FOOTER //
// ./src/pages/employee/childs/request.join.js